// extracted by mini-css-extract-plugin
module.exports =  {"tabWrapper":"tabWrapper___xQrRe","photoWrapper":"photoWrapper___7DV63","textWrapper":"textWrapper___Zo2Ll"};